export const PERMISSIONS = {
    REASSIGN_RO: "REASSIGN_RO",
    SUPPLIER_EDIT: "SUPPLIER_EDIT",
    SUPPLIER_EDIT_LOGS_VIEW: "SUPPLIER_EDIT_LOGS_VIEW",
};

export const ROLES = {
    ADMIN: 'ADMIN',
    RO: 'RO',
    BM: 'BM',
    BCM: 'BCM',
    TVR: 'TVR',
    OPS: 'OPS',
    SANCTION: 'SANCTION',
    ACCOUNTS: 'ACCOUNTS',
    INSURANCE: 'INSURANCE',
    SUPERADMIN: 'SUPERADMIN',
};